export default {
  merchantActivity: {},
  newMessageConversation: {},
  newConversationActivity: {},
  sentMessageStatus: {},
  echoConnectionLost: false,
  importRunning: false,
  importStats: {
    added_contacts: 0,
    failed_contacts: 0,
    total_contacts: 0,
  },
  preventImportToastMessage: false,
  bulkSendProgress: {
    all: 0,
    sent: 0,
    delivered: 0,
    read: 0,
    failed: 0,
  },
  bulkMessageRunningState: false,
  exportRunning: false,
  exportStats: {
    total_contacts: 0,
    added_contacts: 0,
    file_download_url: '',
  },
  conversationActivity: {},
  readUpdate: {},
  lastMessageTime: null,
  pusherTooOld: false,
  reconnectChannel: 0,
  businessAvailabilityChange: 0,
  newRoute: {},
  aiAssistantMessages: {},
};
